import React, {FC} from 'react';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemSecondaryContent} from '../../../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemSecondaryContent';
import {DropdownItemVisitorAvatar} from '../../../../../common/dropdowns/dropdownItemVisitorAvatar';

/*
 * Props.
 */

interface InviteDropdownVisitorItemProps extends DropdownItemProps {
  email: string;
  displayName?: string;
}

/*
 * Component.
 */

export const InviteDropdownVisitorItem: FC<InviteDropdownVisitorItemProps> = ({
  email,
  displayName,
  ...props
}) => (
  <DropdownItem {...props}>
    <DropdownItemVisitorAvatar email={email} />
    <DropdownItemContent isBold>{email}</DropdownItemContent>
    {displayName && displayName !== email && (
      <DropdownItemSecondaryContent>{displayName}</DropdownItemSecondaryContent>
    )}
  </DropdownItem>
);
